<kl-clone-survey [surveyDetails]="surveyDetails" (closeDialog)="ok()"></kl-clone-survey>
